module.exports = __webpack_public_path__ + "img/author.e6d73436.png";